const formModule = {
    namespaced: false,
    state: {
        form: {
            personal: {
                name: null,
                surname: null,
                personIdentificationNumber: null,
                emailAddress: null,
            },
            home: {
                street: null,
                number: null,
                zipCode: null,
                city: null,
                state: null,
                country: null,
            },
            university: {
                dormRoom: null,
                name: null,
                faculty: null,
                semester: null,
                index: null,
            },
            terms: {
                accepted: false,
            },
            device: {
                ipAddress: null,
                macAddress: null,
                browser: null,
                networkEnvironment: [],
            },
        },
    },
    mutations: {
        updatePersonalData(state, payload) {
            state.form.personal = payload;
        },
        updateHomeData(state, payload) {
            state.form.home = payload;
        },
        updateDormAndUniversityData(state, payload) {
            state.form.university = payload;
        },
        updateTermsData(state, payload) {
            state.form.terms = payload;
            console.log(state.form);
        },
        updateDeviceData(state, payload) {
            state.form.device = payload;
        },
    },
    getters: {
        getCompleteForm: (state) => {
            return state.form;
        },
        getPersonalData: (state) => {
            return state.form.personal;
        },
        getHomeData: (state) => {
            return state.form.home;
        },
        getDormAndUniversityData: (state) => {
            return state.form.university;
        },
        getTermsData: (state) => {
            return state.form.terms;
        },
        getDeviceData: (state) => {
            return state.form.device;
        },
    },
    actions: {},
};

export default formModule;
